import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import {useSxStyles as classes} from "../styles/sxStyles";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import InputIcon from '@mui/icons-material/Input';
import RefreshIcon from '@mui/icons-material/Refresh';

const EditOutcomes = (props) => {
    const outcomes = props.outcomes;
    const setOutcomes = props.setOutcomes;
    const setOpenOutcomes = props.setOpenOutcomes
    const saveOutcomes = props.saveOutcomes;
    const [selectedIds, setSelectedIds] = useState(null);

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Button color='primary' size='small' startIcon={<AddIcon/>} onClick={handleAddRecord}>Add Record</Button>
                <Button color='primary' size='small' startIcon={<DeleteIcon/>} onClick={handleDeleteSelected}>Delete Selected</Button>
                <Button color='primary' size='small' startIcon={<InputIcon/>} onClick={handleSave}>Save Changes</Button>
                <Button color='primary' size='small' startIcon={<RefreshIcon/>} onClick={handleCancel}>Cancel</Button>
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    const handleChipChange = (e, row) => {
        if (e) {
            row.chip = (e.target.checked);
        }
    }

    const handleAddRecord = () => {
        let highest = 0;
        let lowest = -1
        if (outcomes && outcomes.length > 0) {
            const highRec = outcomes.reduce((prev, current) => prev && prev.listOrder > current.listOrder ? prev : current);
            highest = highRec.listOrder;
            const newRecs = outcomes.filter(nr => nr.id < 0);
            if (newRecs && newRecs.length > 0) {
                const lowRec = outcomes.reduce((prev, current) => prev && prev.id < current.id ? prev : current);
                if (lowRec) lowest = lowRec.id;
            }
        }
        const newRec = {id: (lowest - 1), listOrder: (highest + 1), reasonDescription: null, chip: false};
        setOutcomes((outcomes) => [...outcomes, newRec]);
    }

    const handleSelectionChange = (ids) => {
        const selected = new Set(ids);
        setSelectedIds(selected);
    }

    const handleDeleteSelected = () => {
        const newOuts = outcomes.filter((o) => !selectedIds.has(o.id));
        setOutcomes(newOuts && newOuts.length > 0 ? newOuts : []);
    }

    const handleCancel = () => {
        setOutcomes(null);
        setOpenOutcomes(false);
    }

    const handleSave = () => {
        saveOutcomes();
    }

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        setOutcomes(outcomes.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    const columns = [
        {field: 'id', headerName: 'ID', width: 0, editable: false},
        {field: 'listOrder', headerName: 'List Order', minWidth: 80, flex: 1, editable: true},
        {field: 'reasonDescription', headerName: 'Description', minWidth: 120, flex: 3, editable: true},
        {
            field: 'chip',
            headerName: 'Chip?',
            minWidth: 50,
            flex: 1,
            editable: true,
            renderCell: (params) => (
                <Checkbox defaultChecked={params.row.chip} onChange={(e) => handleChipChange(e, params.row)} />
            ),
        }
    ];

    return (
        <>
            <Typography variant="h5" color='primary' sx={{...classes.controlPanel, marginTop:'0'}}>Manage Outcome Reasons</Typography>
            <Box sx={{height: 'auto', overflow: 'auto', width: {xs: '50vw', md: '40vw', xl: '35vw'}}}>
                <DataGrid
                    columns={columns}
                    rows={outcomes ? outcomes : []}
                    checkboxSelection
                    disableRowSelectionOnClick
                    rowReordering
                    columnVisibilityModel={{
                        id: false
                    }}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10]}
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                    processRowUpdate={processRowUpdate}
                    onRowSelectionModelChange={(ids) => {handleSelectionChange(ids)}}
                />
            </Box>
        </>
    );
}

export default EditOutcomes;
